import { Trans } from 'react-i18next';

import { assertUnreachable } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarWarningEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { AiAssistantBuyTokensLink } from './AiAssistantBuyTokensLink';
import { AiAssistantTokensQuotaLevel } from './aiAssistantTokensQuota.types';

const t = translationKeys.faults;

const createMessage = (i18nKey: string): JSX.Element => (
   <Trans i18nKey={i18nKey} components={{ link: <AiAssistantBuyTokensLink /> }} />
);

export const dispatchAiAssistantTokensQuotaSnackbarEvent = (level: AiAssistantTokensQuotaLevel): void => {
   switch (level) {
      case 'SUFFICIENT':
         return undefined;
      case 'LOW':
         return dispatchSnackbarWarningEvent(createMessage(t.tokensQuotaLow), { autoHideDelayInMs: 3000 });
      case 'CRITICAL':
         return dispatchSnackbarNegativeEvent(createMessage(t.tokensQuotaCritical), { autoHideDelayInMs: 3000 });
      case 'EXHAUSTED':
         return dispatchSnackbarNegativeEvent(createMessage(t.tokensQuotaExceeded), { autoHideDelayInMs: false });
      default:
         return assertUnreachable(level);
   }
};

export const dispatchAiAssistantRedactionTokensQuotaExceededSnackbarEvent = (): void =>
   dispatchSnackbarNegativeEvent(createMessage(t.redactionTokensQuotaExceeded), { autoHideDelayInMs: false });
